// 纯 HTML 打印工具：通过隐藏 iframe 输出到浏览器打印对话框（自带预览），
// 替代原 LODOP 控件方案，兼容所有现代浏览器，无需安装任何插件。

/**
 * 打印一段 HTML 内容
 * @param {string} bodyHtml 要打印的 HTML（body 内容）
 * @param {object} [options]
 * @param {boolean} [options.landscape] 是否横向纸张（默认 A4 纵向）
 * @param {string} [options.title] 打印任务名（文档标题）
 * @param {Function} [options.onAfterPrint] 打印对话框关闭后的回调（用于连续打印下一张）
 * @param {number} [options.marginTop] 上留白 mm
 * @param {number} [options.marginBottom] 下留白 mm
 * @param {number} [options.marginX] 左右留白 mm（两侧一致）
 * @param {number} [options.fontSize] 正文基础字号 px
 */
export function printHtml(bodyHtml, options = {}) {
  const {
    landscape = false,
    title = "",
    onAfterPrint = null,
    marginTop = 10,
    marginBottom = 10,
    marginX = 10,
    fontSize = 16,
  } = options;

  const iframe = document.createElement("iframe");
  iframe.style.cssText =
    "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;";
  document.body.appendChild(iframe);

  const win = iframe.contentWindow;
  const doc = win.document;
  doc.open();
  doc.write(`<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<title>${title}</title>
<style>
  /* 页边距设为 0：Chromium 打印时不再预留页眉页脚区域，可消除打印自带的
     日期/标题（页眉）与网址/页码（页脚）。留白改由 body padding 提供。 */
  @page { size: A4 ${landscape ? "landscape" : "portrait"}; margin: 0; }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  body {
    font-family: "SimSun", "宋体", serif;
    font-size: ${fontSize}px;
    line-height: 1.4;
    color: #000;
    padding: ${marginTop}mm ${marginX}mm ${marginBottom}mm;
  }
  table { border-collapse: collapse; width: 100%; }
  td, th { border: 1px solid #000; padding: 4px 6px; }
  table.plain td, table.plain th { border: none; padding: 0; }
</style>
</head>
<body>${bodyHtml}</body>
</html>`);
  doc.close();

  win.onafterprint = () => {
    if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    if (onAfterPrint) onAfterPrint();
  };

  const doPrint = () => {
    win.focus();
    win.print();
  };

  // 等待文档（含 base64 图片）渲染完成后再唤起打印
  if (doc.readyState === "complete") {
    setTimeout(doPrint, 50);
  } else {
    iframe.onload = () => setTimeout(doPrint, 50);
  }
}
